// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"cd98b9809bfbbaab3bdb","731":"f4c4095a79f60f9f91de","843":"1edf629696072061a29e","883":"c4a4f23a0f6c5a41e81b"}[chunkId] + ".js";
};